var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"src":'https://player.vimeo.com/video/'+_vm.video_id+'?loop=false&byline=false&portrait=false&title=false&speed=true&transparent=0&gesture=media',"allowfullscreen":"","allowtransparency":"","allow":"autoplay"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }